import { IMAGES, VALUES } from "../../lib/ablemp-data";

export const About = () => {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative bg-[#F4F4F0] bg-grain text-[#0B1015] py-24 md:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Section label */}
        <div className="flex items-center gap-4 text-[11px] uppercase tracking-[0.3em] text-[#475569]">
          <span className="flag-rule" aria-hidden />
          <span>§ 01 — Quem somos</span>
        </div>

        {/* Mission split */}
        <div className="mt-10 grid grid-cols-12 gap-8 lg:gap-12">
          <div className="col-span-12 lg:col-span-7">
            <h2
              data-testid="about-headline"
              className="font-serif-display text-[36px] sm:text-[48px] lg:text-[72px] leading-[1.02] tracking-[-0.02em]"
            >
              Uma associação para garantir que{" "}
              <span className="italic font-light text-[#002776]">
                nenhum meio
              </span>{" "}
              fique de fora.
            </h2>
            <p className="mt-8 text-base md:text-lg text-[#334155] leading-relaxed max-w-2xl">
              A Associação Brasileira de Defesa da Liberdade de Escolha dos
              Meios de Pagamento existe para defender uma ideia simples: o
              cidadão decide como paga. Nosso papel é articular sociedade civil,
              empresas e poder público para que o direito de escolher seja
              preservado em todas as transações do dia a dia.
            </p>
          </div>

          <div className="col-span-12 lg:col-span-5">
            <div
              data-testid="about-image"
              className="relative aspect-[4/5] overflow-hidden border border-[#0B1015]/15"
            >
              <img
                src={IMAGES.societyBW}
                alt="Sociedade brasileira diversa"
                className="absolute inset-0 w-full h-full object-cover grayscale contrast-110"
              />
              <div className="absolute bottom-0 left-0 right-0 p-5 bg-[#F4F4F0]/95 backdrop-blur-sm border-t border-[#0B1015]/15">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#475569]">
                  Missão
                </div>
                <div className="mt-2 font-serif-display text-lg leading-snug">
                  Liberdade financeira, inclusão social e respeito ao
                  consumidor.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mission / Vision / Values bento */}
        <div className="mt-20 grid grid-cols-12 gap-px bg-[#0B1015]/12 border border-[#0B1015]/12">
          <Block
            testid="block-mission"
            tag="Missão"
            title="Garantir o direito de pagar como se quer"
            body="Atuar para que nenhum meio de pagamento seja excluído ou discriminado, promovendo liberdade financeira, inclusão social e respeito ao consumidor."
          />
          <Block
            testid="block-vision"
            tag="Visão"
            title="Um Brasil com mercado plural"
            body="Ser referência nacional em advocacy por mercados de pagamento abertos, competitivos e acessíveis a todos os brasileiros."
          />
          <Block
            testid="block-objective"
            tag="Objetivo"
            title="Liberdade nas transações do dia a dia"
            body="Defender a liberdade de escolha de cada cidadão quanto ao meio de pagamento, sem impedimentos nem imposições."
          />
        </div>

        {/* Values */}
        <div className="mt-20">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <h3 className="font-serif-display text-2xl md:text-3xl">
              Valores que nos guiam
            </h3>
            <span className="text-[11px] uppercase tracking-[0.3em] text-[#475569]">
              03 princípios
            </span>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#0B1015]/12 border border-[#0B1015]/12">
            {VALUES.map((v) => (
              <div
                key={v.n}
                data-testid={`value-${v.n}`}
                className="bg-[#F4F4F0] p-8 md:p-10 group hover:bg-white transition-colors duration-500"
              >
                <div className="flex items-baseline justify-between">
                  <span className="font-serif-display text-3xl text-[#002776]">
                    {v.n}
                  </span>
                  <span className="h-2 w-2 rounded-full bg-[#009B3A] group-hover:bg-[#FEDF00] transition-colors" />
                </div>
                <h4 className="mt-5 font-serif-display text-2xl leading-tight">
                  {v.title}
                </h4>
                <p className="mt-3 text-[15px] text-[#475569] leading-relaxed">
                  {v.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const Block = ({ tag, title, body, testid }) => (
  <div
    data-testid={testid}
    className="col-span-12 md:col-span-4 bg-[#F4F4F0] p-8 md:p-10"
  >
    <div className="text-[10px] uppercase tracking-[0.3em] text-[#002776] font-semibold">
      {tag}
    </div>
    <h4 className="mt-4 font-serif-display text-xl md:text-2xl leading-tight">
      {title}
    </h4>
    <p className="mt-4 text-[15px] text-[#475569] leading-relaxed">{body}</p>
  </div>
);

export default About;
